import * as React from 'react'
import {IFeatureLayerInfo, IImageLegendRowInfo} from '../../interfaces/models'
import {IFeatureLayerInfos} from '../../interfaces/reducers'
import {IAppStore} from '../../../interfaces/reducers'
import {connect} from 'react-redux'
import {config} from '../../reducers/config'

interface OwnProps {
  layerInfos: IFeatureLayerInfos
  visibleLayers: {[key: string]: {}}
  vectorLayerImagesLoaded: boolean
  zoom: number
  pixelsToUnitsFactor: number
  unitMmFactor: number
  dpiFactor: number
}

interface ParentProps {
  theRealThing: boolean //means if its only for display or is really rendered into png/pdf
  mmToPixels(mms: number): string
}

interface DispatchProps {}

type Props = OwnProps & ParentProps & DispatchProps

interface State {}
interface InfoAndRows {
  info: IFeatureLayerInfo
  legendRows: IImageLegendRowInfo[]
}
interface GroupedInfoAndRows {
  [group: string]: InfoAndRows[]
}

class ExportMapControl extends React.Component<Props, State> {
  getLegend() {
    return (
      <div
        style={{
          padding: this.props.mmToPixels(4),
          border: '1px solid gray',
          width: '100%',
          height: '100%',
          boxSizing: 'border-box',
          display: 'flex',
          flexWrap: 'wrap',
          flexDirection: 'column'
        }}
      >
        {this.getLegendGroups()}
      </div>
    )
  }
  getGroupDisplayName(groupName: string): string {
    const conf = config.getConfig()
    if (conf.groupAliases && conf.groupAliases[conf.locale] && conf.groupAliases[conf.locale][groupName]) {
      return conf.groupAliases[conf.locale][groupName]
    }
    return groupName
  }
  getLegendGroups(): JSX.Element[] {
    const groupedInfoRows = this.getGroupedInfoRows()
    const result: JSX.Element[] = []

    for (const group in groupedInfoRows) {
      const layers = this.getLegendLayers(groupedInfoRows[group])
      if (layers.length > 0) {
        result.push(
          <div
            key={group}
            style={{
              maxWidth: this.props.mmToPixels(55),
              minWidth: this.props.mmToPixels(55),
              borderRight: '1px solid gray',
              padding: this.props.mmToPixels(2),
              boxSizing: 'border-box',
              marginRight: this.props.mmToPixels(2)
            }}
          >
            <div
              style={{
                fontWeight: 'bold',
                fontSize: this.props.mmToPixels(4)
              }}
            >
              {this.getGroupDisplayName(group)}
            </div>
            <div style={{marginLeft: group ? this.props.mmToPixels(4) : ''}}>{layers}</div>
          </div>
        )
      } else {
        result.push(<div key={group}></div>)
      }
    }
    return result
  }

  getDpiFactor(): number {
    return this.props.theRealThing ? this.props.dpiFactor : 1
  }

  getLegendLayers(layerInfoRows: InfoAndRows[]): JSX.Element[] {
    const result: JSX.Element[] = []
    const sourceTitleStyle: React.CSSProperties = {
      fontSize: this.props.mmToPixels(3.5),
      maxWidth: this.props.mmToPixels(50)
    }
    const dpiFactor = this.getDpiFactor()
    layerInfoRows.forEach(li => {
      if (li.legendRows.length > 0) {
        if (li.legendRows.length > 1) {
          const rows: JSX.Element[] = []
          li.legendRows.forEach((li, i) => {
            rows.push(
              <div key={i} style={{maxWidth: this.props.mmToPixels(50)}}>
                {this.getLegendRow(li)}
              </div>
            )
          })
          result.push(
            <div key={li.info.url}>
              <div style={sourceTitleStyle}>{li.info.sourceDescription.sourceTitle}</div>
              <div>{rows}</div>
            </div>
          )
        } else {
          result.push(
            <div key={li.info.url} style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
              <div style={sourceTitleStyle}>{li.info.sourceDescription.sourceTitle}</div>
              <div>
                <img
                  alt=""
                  src={li.legendRows[0].base64}
                  style={{
                    width: `${li.legendRows[0].width * dpiFactor}px`,
                    height: `${li.legendRows[0].height * dpiFactor}px`
                  }}
                ></img>
              </div>
            </div>
          )
        }
      }
    })
    return result
  }

  getLegendRow(legendRow: IImageLegendRowInfo): JSX.Element {
    const dpiFactor = this.getDpiFactor()
    return (
      <div
        key={legendRow.label}
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontSize: this.props.mmToPixels(2.5)
        }}
      >
        <div>{legendRow.label}</div>
        <img
          alt=""
          src={legendRow.base64}
          style={{width: `${legendRow.width * dpiFactor}px`, height: `${legendRow.height * dpiFactor}px`}}
        ></img>
      </div>
    )
  }

  getGroupedInfoRows(): GroupedInfoAndRows {
    const visible: IFeatureLayerInfos = {}
    for (const key in this.props.layerInfos) {
      if (this.props.visibleLayers[key]) {
        visible[key] = this.props.layerInfos[key]
      }
    }
    const infoAndRows: InfoAndRows[] = []
    for (const key in visible) {
      const layerInfo = visible[key]
      infoAndRows.push({info: layerInfo, legendRows: layerInfo.imageLegendRows})
    }
    const groupedInfoAndRows: GroupedInfoAndRows = {}
    infoAndRows.forEach(i => {
      if (!groupedInfoAndRows[i.info.sourceDescription.groupLabel]) {
        groupedInfoAndRows[i.info.sourceDescription.groupLabel] = []
      }
      groupedInfoAndRows[i.info.sourceDescription.groupLabel].push(i)
    })
    return groupedInfoAndRows
  }
  render() {
    return this.getLegend()
  }
}

const mapStateToProps = (store: IAppStore) => {
  return {
    layerInfos: store.layerInfos.featureLayerInfos,
    visibleLayers: store.layerInfos.visibleLayers,
    vectorLayerImagesLoaded: store.layerInfos.vectorLayerImagesLoaded,
    zoom: store.map.zoom,
    pixelsToUnitsFactor: store.exportMap.pixelsToUnitsFactor,
    unitMmFactor: store.exportMap.unitMmFactor,
    dpiFactor: store.exportMap.dpiFactor
  }
}

export default connect<OwnProps, DispatchProps, ParentProps>(mapStateToProps, {})(ExportMapControl)
